/** Include the zone for historical DST rules, plus the legacy offset. */
export function browserTimeZoneQuery(): string {
  return new URLSearchParams({
    tz: String(new Date().getTimezoneOffset()),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }).toString();
}
